import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

const Projects = () => {
    const [activeFilter, setActiveFilter] = useState('all');

    const projects = [
        {
            id: 1,
            title: 'Dubai Marina High-Rise',
            category: 'civil',
            type: 'Residential Tower',
            location: 'Dubai Marina',
            duration: '18 Months',
            size: '45,000 sq.ft',
            image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            description: 'Complete civil construction and MEP services for a luxury residential tower.',
            services: ['Civil Construction', 'HVAC Systems', 'Electrical', 'Plumbing', 'Waterproofing']
        },
        {
            id: 2,
            title: 'Jumeirah Commercial Complex',
            category: 'commercial',
            type: 'Shopping Mall',
            location: 'Jumeirah',
            duration: '24 Months',
            size: '85,000 sq.ft',
            image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            description: 'Full-scale commercial complex development with modern amenities.',
            services: ['Civil Works', 'HVAC', 'Electrical', 'Fire Protection', 'Plumbing']
        },
        {
            id: 3,
            title: 'Al Barsha Hospital Extension',
            category: 'healthcare',
            type: 'Healthcare Facility',
            location: 'Al Barsha',
            duration: '15 Months',
            size: '35,000 sq.ft',
            image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            description: 'Hospital extension project with specialized medical facilities.',
            services: ['HVAC Systems', 'Electrical', 'Plumbing', 'Medical Gas', 'Fire Safety']
        },
        {
            id: 4,
            title: 'Business Bay Office Tower',
            category: 'commercial',
            type: 'Office Building',
            location: 'Business Bay',
            duration: '20 Months',
            size: '60,000 sq.ft',
            image: 'https://images.unsplash.com/photo-1487956382158-bb926046304a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            description: 'Grade A office building with state-of-the-art facilities.',
            services: ['Civil Construction', 'HVAC', 'Electrical', 'Elevators', 'BMS']
        },
        {
            id: 5,
            title: 'Palm Jumeirah Villa Complex',
            category: 'residential',
            type: 'Luxury Villas',
            location: 'Palm Jumeirah',
            duration: '12 Months',
            size: '25,000 sq.ft',
            image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            description: 'Luxury villa complex with premium finishes and amenities.',
            services: ['Civil Works', 'HVAC', 'Electrical', 'Plumbing', 'Interior']
        },
        {
            id: 6,
            title: 'Dubai Industrial Park',
            category: 'industrial',
            type: 'Warehouse Complex',
            location: 'Dubai Industrial City',
            duration: '16 Months',
            size: '120,000 sq.ft',
            image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            description: 'Large-scale industrial warehouse with specialized facilities.',
            services: ['Structural Steel', 'HVAC', 'Electrical', 'Plumbing', 'Fire Protection']
        },
        {
            id: 7,
            title: 'Dubai Mall Retail Space',
            category: 'commercial',
            type: 'Retail Fit-out',
            location: 'Downtown Dubai',
            duration: '8 Months',
            size: '15,000 sq.ft',
            image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            description: 'Premium retail space fit-out with luxury finishes.',
            services: ['Interior Fit-out', 'HVAC', 'Electrical', 'Plumbing', 'Lighting']
        },
        {
            id: 8,
            title: 'Academic City University',
            category: 'education',
            type: 'Educational Campus',
            location: 'Academic City',
            duration: '30 Months',
            size: '150,000 sq.ft',
            image: 'https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            description: 'University campus construction with modern educational facilities.',
            services: ['Civil Construction', 'HVAC', 'Electrical', 'Plumbing', 'IT Infrastructure']
        },
    ];

    const filters = [
        { id: 'all', label: 'All Projects' },
        { id: 'civil', label: 'Civil Construction' },
        { id: 'commercial', label: 'Commercial' },
        { id: 'residential', label: 'Residential' },
        { id: 'industrial', label: 'Industrial' },
        { id: 'healthcare', label: 'Healthcare' },
    ];

    const filteredProjects = activeFilter === 'all'
        ? projects
        : projects.filter(project => project.category === activeFilter);

    return (
        <>
            <Helmet>
                <title>Our Projects | LAMSAT Engineering Portfolio</title>
                <meta
                    name="description"
                    content="Explore LAMSAT's portfolio of completed projects including high-rise buildings, commercial complexes, and industrial facilities in Dubai."
                />
                <meta property="og:title" content="LAMSAT Project Portfolio" />
                <meta property="og:description" content="View our completed engineering projects across Dubai and UAE." />
            </Helmet>

            {/* Hero Section - FIXED: Added margin-top for navbar space */}
            <section className="py-5 bg-primary-blue" style={{ marginTop: '80px' }}>
                <div className="container">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="text-center text-white"
                    >
                        <h1 className="display-5 fw-bold mb-3">Our Projects</h1>
                        {/* FIXED: Removed opacity class and made text clearly visible */}
                        <p className="lead mb-0 text-off-white" style={{ fontSize: '1.1rem' }}>
                            Showcasing excellence across Dubai and UAE
                        </p>
                    </motion.div>
                </div>
            </section>

            {/* Project Stats */}
            <section className="py-5">
                <div className="container">
                    <div className="row g-3">
                        <motion.div
                            className="col-md-3 col-6"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            viewport={{ once: true }}
                        >
                            <div className="text-center">
                                <div className="stat-number">72+</div>
                                <h6 className="mb-0 text-dark-charcoal">Projects Completed</h6>
                            </div>
                        </motion.div>

                        <motion.div
                            className="col-md-3 col-6"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.1 }}
                            viewport={{ once: true }}
                        >
                            <div className="text-center">
                                <div className="stat-number">45+</div>
                                <h6 className="mb-0 text-dark-charcoal">Happy Clients</h6>
                            </div>
                        </motion.div>

                        <motion.div
                            className="col-md-3 col-6"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            viewport={{ once: true }}
                        >
                            <div className="text-center">
                                <div className="stat-number">30+</div>
                                <h6 className="mb-0 text-dark-charcoal">Cities Covered</h6>
                            </div>
                        </motion.div>

                        <motion.div
                            className="col-md-3 col-6"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.3 }}
                            viewport={{ once: true }}
                        >
                            <div className="text-center">
                                <div className="stat-number">500K+</div>
                                <h6 className="mb-0 text-dark-charcoal">Sq. Ft Completed</h6>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </section>

            {/* Project Filters */}
            <section className="py-5 bg-off-white">
                <div className="container">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                        className="text-center mb-5"
                    >
                        <h2 className="section-title d-inline-block">Project Portfolio</h2>
                        {/* FIXED: Made subtitle always visible with proper styling */}
                        <p className="text-cool-grey mt-3 mb-0" style={{ display: 'block' }}>
                            Browse our diverse range of completed projects
                        </p>
                    </motion.div>

                    {/* Filter Buttons */}
                    <div className="row mb-5">
                        <div className="col-12">
                            <div className="d-flex flex-wrap justify-content-center gap-2">
                                {filters.map((filter) => (
                                    <button
                                        key={filter.id}
                                        className={`btn ${activeFilter === filter.id ? 'btn-primary-custom' : 'btn-outline-custom'} mb-2`}
                                        onClick={() => setActiveFilter(filter.id)}
                                        style={{ 
                                            padding: '8px 16px',
                                            fontSize: '0.875rem'
                                        }}
                                    >
                                        {filter.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Projects Grid */}
                    <div className="row g-4">
                        {filteredProjects.map((project, index) => (
                            <motion.div
                                key={project.id}
                                className="col-xl-3 col-lg-4 col-md-6"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                viewport={{ once: true }}
                            >
                                <div className="card project-card h-100">
                                    <div className="position-relative">
                                        <img
                                            src={project.image}
                                            className="card-img-top object-fit-cover"
                                            alt={project.title}
                                            style={{ height: '200px', width: '100%' }}
                                            loading="lazy"
                                        />
                                        <div className="position-absolute top-0 end-0 m-3">
                                            <span className="badge bg-primary-red">{project.type}</span>
                                        </div>
                                    </div>
                                    <div className="card-body d-flex flex-column">
                                        <h5 className="card-title mb-3 text-primary-blue">{project.title}</h5>
                                        <div className="row g-2 mb-3">
                                            <div className="col-6">
                                                <div className="d-flex align-items-center">
                                                    <i className="fas fa-map-marker-alt text-primary-red me-2" style={{ fontSize: '0.8rem' }}></i>
                                                    <small className="text-cool-grey text-truncate">{project.location}</small>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="d-flex align-items-center">
                                                    <i className="fas fa-clock text-primary-red me-2" style={{ fontSize: '0.8rem' }}></i>
                                                    <small className="text-cool-grey">{project.duration}</small>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="d-flex align-items-center">
                                                    <i className="fas fa-expand-arrows-alt text-primary-red me-2" style={{ fontSize: '0.8rem' }}></i>
                                                    <small className="text-cool-grey">{project.size}</small>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="d-flex align-items-center">
                                                    <i className="fas fa-building text-primary-red me-2" style={{ fontSize: '0.8rem' }}></i>
                                                    <small className="text-cool-grey text-truncate">{project.category}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="card-text text-cool-grey small mb-4 flex-grow-1">{project.description}</p>

                                        <div className="mb-3">
                                            <h6 className="small fw-bold mb-2 text-dark-charcoal">Services Provided:</h6>
                                            {/* FIXED: Changed to inline-flex for horizontal badges */}
                                            <div className="d-inline-flex flex-wrap gap-1">
                                                {project.services.map((service, i) => (
                                                    <span 
                                                        key={i} 
                                                        className="badge bg-primary-blue" 
                                                        style={{ 
                                                            fontSize: '0.7rem', 
                                                            padding: '4px 8px',
                                                            margin: '0 2px 2px 0',
                                                            display: 'inline-block'
                                                        }}
                                                    >
                                                        {service}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>

                                        <button className="btn btn-outline-custom w-100 mt-auto" data-bs-toggle="modal" data-bs-target={`#projectModal${project.id}`}>
                                            View Details
                                        </button>
                                    </div>
                                </div>

                                {/* Project Modal */}
                                <div className="modal fade" id={`projectModal${project.id}`} tabIndex="-1" aria-hidden="true">
                                    <div className="modal-dialog modal-lg modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">{project.title}</h5>
                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                            </div>
                                            <div className="modal-body">
                                                <img src={project.image} alt={project.title} className="img-fluid rounded mb-4" />
                                                <h6>Project Overview</h6>
                                                <p>{project.description}</p>

                                                <div className="row mb-4">
                                                    <div className="col-md-6">
                                                        <h6>Project Details</h6>
                                                        <table className="table table-sm">
                                                            <tbody>
                                                                <tr>
                                                                    <td><strong>Location:</strong></td>
                                                                    <td>{project.location}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Duration:</strong></td>
                                                                    <td>{project.duration}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Size:</strong></td>
                                                                    <td>{project.size}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Type:</strong></td>
                                                                    <td>{project.type}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h6>Services Provided</h6>
                                                        <ul className="list-unstyled">
                                                            {project.services.map((service, i) => (
                                                                <li key={i} className="mb-1">
                                                                    <i className="fas fa-check-circle text-primary-red me-2"></i>
                                                                    {service}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>

                                                <h6>Key Achievements</h6>
                                                <ul>
                                                    <li>Completed ahead of schedule</li>
                                                    <li>Zero safety incidents</li>
                                                    <li>Exceeded client quality expectations</li>
                                                    <li>Sustainable construction practices implemented</li>
                                                </ul>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                                <button type="button" className="btn btn-primary-custom">Request Similar Project</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Testimonials */}
            <section className="py-5">
                <div className="container">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                        className="text-center mb-5"
                    >
                        <h2 className="section-title d-inline-block">Client Testimonials</h2>
                        {/* FIXED: Made subtitle always visible */}
                        <p className="text-cool-grey mt-3 mb-0" style={{ display: 'block' }}>
                            What our clients say about our work
                        </p>
                    </motion.div>

                    <div className="row g-4">
                        {[
                            {
                                name: 'Ahmed Al Mansoori',
                                company: 'Emaar Properties',
                                role: 'Project Director',
                                text: 'LAMSAT delivered exceptional quality on our Dubai Marina project. Their attention to detail and commitment to timelines was impressive.',
                                image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
                            },
                            {
                                name: 'Sarah Johnson',
                                company: 'Nakheel PJSC',
                                role: 'Construction Manager',
                                text: 'Professional, reliable, and technically excellent. LAMSAT handled complex HVAC installations with precision and expertise.',
                                image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
                            },
                            {
                                name: 'Mohammed Hassan',
                                company: 'Dubai Healthcare City',
                                role: 'Facilities Director',
                                text: 'Their healthcare facility work exceeded all standards. Critical systems installation was flawless and met all regulatory requirements.',
                                image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
                            },
                        ].map((testimonial, index) => (
                            <motion.div
                                key={index}
                                className="col-lg-4 col-md-6 col-12"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                viewport={{ once: true }}
                            >
                                <div className="card h-100 border-0 shadow-sm">
                                    <div className="card-body p-4">
                                        <div className="d-flex align-items-center mb-4">
                                            <img
                                                src={testimonial.image}
                                                alt={testimonial.name}
                                                className="rounded-circle me-3 object-fit-cover"
                                                style={{ width: '60px', height: '60px' }}
                                            />
                                            <div>
                                                <h6 className="mb-1 text-dark-charcoal">{testimonial.name}</h6>
                                                <p className="small text-cool-grey mb-0">{testimonial.role}</p>
                                                <p className="small text-cool-grey mb-0">{testimonial.company}</p>
                                            </div>
                                        </div>
                                        <p className="fst-italic text-cool-grey mb-0">"{testimonial.text}"</p>
                                        <div className="text-primary-red mt-3">
                                            <i className="fas fa-star"></i>
                                            <i className="fas fa-star"></i>
                                            <i className="fas fa-star"></i>
                                            <i className="fas fa-star"></i>
                                            <i className="fas fa-star"></i>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-5 bg-primary-blue">
                <div className="container">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                        className="text-center text-white"
                    >
                        <h2 className="mb-3 mb-md-4">Ready to Start Your Project?</h2>
                        <p className="mb-4 text-off-white">
                            Contact us today for a consultation and let's discuss how we can help bring your vision to life.
                        </p>
                        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                            <a href="/contact" className="btn btn-primary-custom">
                                Get Free Quote
                            </a>
                            <a href="/services" className="btn btn-outline-custom">
                                View Our Services
                            </a>
                        </div>
                    </motion.div>
                </div>
            </section>
        </>
    );
};

export default Projects;